var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47 14.53a.75.75 0 010-1.06l4.646-4.647a1.25 1.25 0 011.768 0l4.646 4.647a.75.75 0 01-1.06 1.06L12 10.06l-4.47 4.47a.75.75 0 01-1.06 0z",
    fill: "currentColor"
  })));
}
SvgChevronUp.displayName = 'ChevronUp';
export default SvgChevronUp;